import React, { Component } from 'react';

import PropTypes from 'prop-types';
import StreamDotPlotChart from '../../../common/components/charts/stream-dot-plot-chart';
import { connect } from 'react-redux';
import { dmarcAuthVisSelector } from '../../selectors/dmarc-auth-selectors';
import { selectedIntervalSelector } from '../../selectors/reports-selectors';

export class DmarcAuthVisContainer extends Component{
    constructor( props ){
        super( props );

        this.state = {
            height: 250,
            margin: {
                bottom: 48,
                left: 0,
                right: 8,
                top: 8,
            },
            width: 800
        };
    }

    render(){
        const { isLoading, selectedInterval, dmarcAuthVisData } = this.props;
        const { height, margin, width } = this.state;

        const options = { height, margin, width };

        const dotPlotOptions = {
            key: 'passRate',
        };

        const streamOptions = {
            keys: ['total'],
        };

        return (
            <StreamDotPlotChart
                data={dmarcAuthVisData}
                xKey="date"
                dotPlotOptions={dotPlotOptions}
                streamOptions={streamOptions}
                interval={selectedInterval}
                isLoading={isLoading}
                options={options}
            />
        );
    }
};

/* istanbul ignore next */
const mapStateToProps = state => {
    return {
        dmarcAuthVisData: dmarcAuthVisSelector( state ),
        selectedInterval: selectedIntervalSelector( state ),
    };
};

DmarcAuthVisContainer.propTypes = {
    dmarcAuthVisData: PropTypes.array.isRequired,
    isLoading: PropTypes.bool.isRequired,
    selectedInterval: PropTypes.string,
};

export default connect( mapStateToProps )( DmarcAuthVisContainer );
